import React, { Component } from 'react';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import NavBar from '../../../../_components/common/Navbar';
import Footer from '../../../../_components/common/Footer';
import SettingsHead from '../../../../_components/common/SettingsHead'
import CustomTableNew from '../../../../_components/common/CustomTableNew'
import { manageBatchActions } from '../../../../_actions/organisations/manageBatchList.action'
import ModalNew2 from '../../../../_components/common/ModalNew2'
import { CommonBreadCrumb } from '../../../../_components/common/CommonBreadCrumb'
import { BatchDetail, updateMandateGroup } from '../formData';
import { tables } from './CustomColumnTable'
import TableNew from '../../../../_components/common/TableNew';
import { reportThemeData, setDevPlan } from '../formData';
import { organisationAction } from '../../../../_actions/organisation.action'
import { compareBy } from '../component/CompareFunc';
import { developmentPlanActions } from '../../../../_actions';
import { LoaderComp } from '../../../../_components/common/LoaderComp/Loadercomp';
import Page404 from '../../../404page';
import { withRouter } from 'react-router-dom';
import './BatchDetails.css'

var moment = require('moment');


class BatchDetails extends Component {
    constructor(props) {
        super(props);

    }
    state = {
        locationId: 0,
        orgId: 0,
        sellerId: 0,
        batchId: 0,
        getImpId: false,
        batchIdState: 0,

        addBatchDetailModal: false,
        buttonBatchDetailsData: [],
        checkBoxData: [],
        removeFromBatchModal: false,
        setExpiryDateModal: false,
        unsubmitAssessmentModal: false,
        resetAssessmentModal: false,


        deleteReportModal: false,
        setReportThemeModal: false,
        setCustomReportAccess: false,
        setDevelopmentPlanModal: false,
        removeCustomReportAccess: false,
        tableModal: false,
        topTextModal: '',
        bottomTextModal: '',
        sortTypeallot: false,
        organisationallotTable: '',
        addIndividualAnalytics: false,
        removeIndividualAnalytics: false,
        deleteReportText: '',
        breadCrumbData: [],
        submittedAssessment: {
            status: false,
            stringArr: ''
        },


        setCustomReportData: [],
        vviSelected: false,

        changeMandateGroup: false,
        expiryValue: '',
        expiryPlaceholderValidator: [],



        hasProperOrgId: true,
        idLoader: true,
    }

    componentDidMount() {


        const { dispatch, } = this.props;


        let sellerIdLocal = localStorage.getItem('seller_id')
        let orgIdLocal = localStorage.getItem('orgId')
        let userType = localStorage.getItem('usertype')




        dispatch(organisationAction.getOrganisation((callback_Data) => {
            this.getSellerOrgId()
        }))

        if (userType.includes('super_admin')) {

            dispatch(developmentPlanActions.getDevelopmentPlan())

            dispatch(manageBatchActions.getThemeReportAction())

        }

        dispatch(manageBatchActions.getCustomReportAction())


        let orgIdFromPath = this.props.location.pathname.split('/')
        let batchIdFromPath = orgIdFromPath[orgIdFromPath.length - 1]
        let orgIdPath = orgIdFromPath[orgIdFromPath.length - 3]


        this.setState({
            locationId: orgIdPath,
            batchIdState: batchIdFromPath
        }, () => {
            if ((sellerIdLocal !== 'null' || orgIdLocal !== 'null') && !userType.includes('super_admin')) {
                this.setState({
                    breadCrumbData: [
                        {
                            link: '/admin/app/dashboard',
                            name: 'ADMIN'
                        }, {
                            link: '/admin/app/organisation',
                            name: 'ORGANISATION'
                        }, {
                            link: `/admin/app/organisation/${this.state.locationId}`,
                            name: 'ORGANISATION DETAILS'
                        }, {
                            link: `/admin/app/organisation/${this.state.locationId}/manageBatches`,
                            name: 'MANAGE BATCHES'
                        }, {
                            link: ``,
                            name: 'BATCH DETAILS'
                        }
                    ],
                    buttonBatchDetailsData: [
                        {
                            id: 1,
                            heading: "REMOVE FROM BATCH",
                            state: this.state.removeFromBatchModal,
                            toggler: this.removeFromBatchToggle.bind(this),
                            disabled: "disabled",

                        },
                        {
                            id: 2,
                            heading: "CHANGE EXPIRY DATE",
                            state: this.state.setReportThemeModal,
                            toggler: this.setExpiryDateToggle.bind(this),
                            disabled: "disabled",


                        },
                        {
                            id: 4,
                            heading: "TOGGLE REPORT",
                            state: this.state.toggleReportModal,
                            toggler: this.toggleReportToggle.bind(this),
                            disabled: "disabled",
                        },

                        {
                            id: 6,
                            heading: "DELETE ASSESSMENT",
                            state: this.state.deleteReportModal,
                            toggler: this.deleteReportToggle.bind(this),
                            disabled: "disabled",

                        }
                    ]
                }, () => {
                    if (orgIdLocal !== 'null') {
                        this.setState({
                            breadCrumbData: [
                                {
                                    link: '/admin/app/dashboard',
                                    name: 'ADMIN'
                                }, {
                                    link: `/admin/app/organisation/${this.state.locationId}/manageBatches`,
                                    name: 'MANAGE BATCHES'
                                }, {
                                    link: ``,
                                    name: 'BATCH DETAILS'
                                }
                            ],
                            buttonBatchDetailsData: [
                                {
                                    id: 1,
                                    heading: "REMOVE FROM BATCH",
                                    state: this.state.removeFromBatchModal,
                                    toggler: this.removeFromBatchToggle.bind(this),
                                    disabled: "disabled",

                                },
                                {
                                    id: 6,
                                    heading: "DELETE ASSESSMENT",
                                    state: this.state.deleteReportModal,
                                    toggler: this.deleteReportToggle.bind(this),
                                    disabled: "disabled",

                                },
                            ]
                        })
                    }
                })
            } else {
                this.setState({
                    breadCrumbData: [
                        {
                            link: '/admin/app/dashboard',
                            name: 'ADMIN'
                        }, {
                            link: '/admin/app/organisation',
                            name: 'ORGANISATION'
                        }, {
                            link: `/admin/app/organisation/${this.state.locationId}`,
                            name: 'ORGANISATION DETAILS'
                        }, {
                            link: `/admin/app/organisation/${this.state.locationId}/manageBatches`,
                            name: 'MANAGE BATCHES'
                        }, {
                            link: ``,
                            name: 'BATCH DETAILS'
                        }
                    ],
                    buttonBatchDetailsData: [
                        {
                            id: 1,
                            heading: "REMOVE FROM BATCH",
                            state: this.state.removeFromBatchModal,
                            toggler: this.removeFromBatchToggle.bind(this),
                            disabled: "disabled",

                        },
                        {
                            id: 2,
                            heading: "CHANGE EXPIRY DATE",
                            state: this.state.setReportThemeModal,
                            toggler: this.setExpiryDateToggle.bind(this),
                            disabled: "disabled",


                        },
                        {
                            id: 3,
                            heading: "UNSUBMIT ASSESSMENT",
                            state: this.state.unsubmitAssessmentModal,
                            toggler: this.unsubmitAssessmentToggle.bind(this),

                            disabled: "disabled"
                        },
                        {
                            id: 4,
                            heading: "TOGGLE REPORT",
                            state: this.state.toggleReportModal,
                            toggler: this.toggleReportToggle.bind(this),
                            disabled: "disabled",
                        },
                        {
                            id: 6,
                            heading: "DELETE ASSESSMENT",
                            state: this.state.deleteReportModal,
                            toggler: this.deleteReportToggle.bind(this),
                            disabled: "disabled",

                        },
                        // {
                        //     id: 7,
                        //     heading: "SET REPORT THEME",
                        //     state: this.state.setReportThemeModal,
                        //     toggler: this.setReportThemeToggle.bind(this),
                        //     disabled: "disabled",

                        // },
                        {
                            id: 8,
                            heading: "DEVELOPMENT PLAN",
                            state: this.state.setDevelopmentPlanModal,
                            toggler: this.setDevelopmentPlanToggle.bind(this),
                            disabled: "disabled"
                        },
                        {
                            id: 9,
                            heading: "SET REPORT ACCESS",
                            state: false,
                            toggler: this.setCustomReportToggle.bind(this),
                            disabled: "disabled"
                        },
                        {
                            id: 10,
                            heading: "REMOVE CUSTOME REPORT ACCESS",
                            state: false,
                            toggler: this.removeCustomReportToggle.bind(this),
                            disabled: "disabled"
                        },
                        {
                            id: 11, // Make sure this ID is unique
                            heading: "BULK UPLOAD",
                            state: false,
                            toggler: this.handleBulkUpload.bind(this),
                            doNotDisable: true
                        },
                        {
                            id: 13, // Use a unique ID
                            heading: "RESET ASSESSMENT",
                            state: this.state.resetAssessmentModal,
                            toggler: this.resetAssessmentToggle.bind(this),
                            disabled: "disabled"
                        }





                        // {
                        //     id: 11,
                        //     heading: "Add Individual Analytics",
                        //     state: false,
                        //     toggler: this.addIndividualAnalyticsToggle.bind(this),
                        //     disabled: "disabled"
                        // },
                        // {
                        //     id: 12,
                        //     heading: "Remove Individual Analytics",
                        //     state: false,
                        //     toggler: this.removeIndividualAnalyticsToggle.bind(this),
                        //     disabled: "disabled"
                        // }
                    ]
                })
            }
        })

    }

    addIndividualAnalyticsToggle(data) {
        this.setState({
            addIndividualAnalytics: data
        })
    }

    removeIndividualAnalyticsToggle(data) {
        this.setState({
            removeIndividualAnalytics: data
        })
    }

    addIndividualAnalyticsAction = (data) => {
        const { dispatch } = this.props;
        let dataObj = {
            users_id: []
        }
        this.state.checkBoxData.map(val => {
            dataObj.users_id.push(val.id)
        })
        dispatch(manageBatchActions.addAnalyticsAction({
            data: dataObj,
            get: {
                data: {
                    batch_id: this.state.batchIdState,
                    organisation_id: this.state.orgId
                }
            }
        }))

    }

    removeIndividualAnalyticsAction = (data) => {
        const { dispatch } = this.props;
        let dataObj = {
            users_id: []
        }
        this.state.checkBoxData.map(val => {
            dataObj.users_id.push(val.id)
        })
        dispatch(manageBatchActions.removeAnalyticsAction({
            data: dataObj,
            get: {
                data: {
                    batch_id: this.state.batchIdState,
                    organisation_id: this.state.orgId
                }
            }
        }))

    }

    setCustomReportToggle(data) {

        let checkBoxData = [...this.state.checkBoxData]
        let setCustomReportData = []
        let counter = 0
        let vviSelected = false

        checkBoxData.map(val => {
            if (!val.default_report) {
                counter++
            }
            if (!val.instrument__is_custom_report_enabled && !val.instrument__is_development_plan_enabled) {
                vviSelected = true
            }
        })



        if (!vviSelected) {
            if (checkBoxData.length === 1) {
                checkBoxData.map(val => {

                    setCustomReportData = [...val.report_list]
                })
            } else if (counter === 0) {

                checkBoxData.map(val => {

                    setCustomReportData = [...val.report_list]
                })
            }
        }

        this.setState({
            vviSelected,
            setCustomReportData,
            setCustomReportAccess: data
        })
    }

    removeCustomReportToggle(data) {
        let checkBoxData = [...this.state.checkBoxData]

        let vviSelected = false

        checkBoxData.map(val => {
            if (!val.instrument__is_custom_report_enabled && !val.instrument__is_development_plan_enabled) {
                vviSelected = true
            }
        })
        this.setState({
            vviSelected,
            removeCustomReportAccess: data
        })
    }

    handleBulkUpload() {
        const { orgId } = this.state;
        this.props.history.push(`/admin/app/organisation/${orgId}/uploadAssessment`);
    }





    removeCustomReportAction(data) {
        const { dispatch } = this.props;

        let dataName = []
        data.map(val => {
            dataName.push({
                id: val.id,
                relation_group_name: val.name
            })
        })
        let selectedUserId = [];
        this.state.checkBoxData.map(value => {
            selectedUserId.push(value.id)

        })
        let postData = {
            get: {
                data: {
                    batch_id: this.state.batchIdState,
                    organisation_id: this.state.orgId
                }
            },
            data: {
                users_assessment_id: selectedUserId,
                custom_access: 1,
                assessment_report_list: dataName
            }
        }

        dispatch(manageBatchActions.setReportCustom(postData))
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.allotedUnallotedList !== this.props.allotedUnallotedList) {
            this.props.allotedUnallotedList === '' &&
                this.selectAllBatchDetailsBox(this.state.checkBoxData, false)
        }
        if (prevProps.batchDetails !== this.props.batchDetails) {
            if (this.props.batchDetails !== '') {
                if (this.props.batchDetails.length) {
                    BatchDetail[0].value = this.props.batchDetails[0].min_respondent
                    BatchDetail[0].valid = true
                } else {
                    this.props.history.replace('/404-page-not-found');
                }
            }

        }
    }

    setDevelopmentPlanToggle(data) {
        let checkBoxData = [...this.state.checkBoxData]

        let vviSelected = false

        checkBoxData.map(val => {
            if (!val.instrument__is_custom_report_enabled && !val.instrument__is_development_plan_enabled) {
                vviSelected = true
            }
        })

        this.setState({
            vviSelected,
            setDevelopmentPlanModal: data
        })
    }

    filterData = (data) => {
        this.setState({
            participantData: data
        });
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal
        });
    }

    toggleBatchDetail(data) {
        if (this.props.batchDetails !== '') {
            BatchDetail[0].value = this.props.batchDetails[0].min_respondent
        }
        this.setState({
            addBatchDetailModal: data
        })
    }

    onUpdateMinRes(data) {
        const { dispatch } = this.props
        data.min_respondent = parseInt(data.min_respondent, 10)

        dispatch(manageBatchActions.updateMinResAction({
            orgId: this.state.orgId,
            linkId: this.state.batchIdState,
            data
        }))
    }

    selectAllBatchDetailsBox(data, clickToggle) {
        const { buttonBatchDetailsData } = this.state;

        if (clickToggle === true) {
            // Check if any selected assessment is LOI-Self or VVI
            const hasDisabledInstruments = data.some(item =>
                item.instrument__instrument_name === "LOI-Self" ||
                item.instrument__instrument_name === "VVI"
            );

            buttonBatchDetailsData.map(val => {
                if (val.disabled !== undefined) {
                    // Special handling for unsubmit button (id: 3)
                    if (val.id === 3) {
                        val.disabled = hasDisabledInstruments ? 'disabled' : '';
                    } else {
                        val.disabled = '';
                    }
                }
                return val;
            });

            this.setState({
                reRenderSettingsHead: 2,
                paticipantListData: data
            });
        } else {
            buttonBatchDetailsData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = 'disabled';
                }
                return val;
            });

            this.setState({
                reRenderSettingsHead: 1,
                paticipantListData: data
            });
        }
    }

    getSelectedData(data) {
        if (data.length !== 0) {
            // Check if any selected assessment is LOI-Self or VVI
            const hasDisabledInstruments = data.some(item =>
                item.instrument__instrument_name === "LOI-Self" ||
                item.instrument__instrument_name === "VVI"
            );

            // Update buttonBatchDetailsData to set unsubmit button state
            const updatedButtonData = this.state.buttonBatchDetailsData.map(button => {
                if (button.id === 3) { // ID 3 is for UNSUBMIT ASSESSMENT button
                    return {
                        ...button,
                        disabled: hasDisabledInstruments ? 'disabled' : ''
                    };
                }
                return button;
            });

            this.setState({
                checkBoxData: data,
                buttonBatchDetailsData: updatedButtonData
            }, () => {
                this.selectAllBatchDetailsBox(this.state.checkBoxData, true);
            });
        } else if (data.length === 0) {
            // Reset button states when no checkboxes are selected
            const updatedButtonData = this.state.buttonBatchDetailsData.map(button => {
                if (button.disabled !== undefined) {
                    return {
                        ...button,
                        disabled: 'disabled'
                    };
                }
                return button;
            });

            this.setState({
                checkBoxData: data,
                buttonBatchDetailsData: updatedButtonData
            }, () => {
                this.selectAllBatchDetailsBox(this.state.checkBoxData, false);
            });
        }
    }


    removeFromBatchToggle(data) {
        this.setState({
            removeFromBatchModal: data
        })
    }

    unsubmitAssessmentToggle(data) {
        this.setState({
            unsubmitAssessmentModal: data
        })
    }

    resetAssessmentToggle(data) {
        this.setState({
            resetAssessmentModal: data
        })
    }





    deleteReportToggle(data) {
        this.setState({
            deleteReportModal: data,
            deleteReportText: 'Are you sure you want to delete these assessments?'
        })
    }
    toggleReportToggle(data) {
        const enabledCount = this.state.checkBoxData.filter(item => item.enable_report).length;
        const disabledCount = this.state.checkBoxData.length - enabledCount;

        let action, affectedCount;
        if (enabledCount >= disabledCount) {
            action = 'disable';
            affectedCount = enabledCount;
        } else {
            action = 'enable';
            affectedCount = disabledCount;
        }

        this.setState({
            toggleReportModal: data,
            reportAction: action,
            affectedReportCount: affectedCount
        });
    }



    setExpiryDateToggle(data) {
        const { allotedUnallotedList } = this.props;
        let arrayEmailsSubmitted = []
        this.state.checkBoxData.map(value => {
            allotedUnallotedList.map(val => {
                if (val.id === value.id) {
                    if (value.is_submited) {
                        arrayEmailsSubmitted.push(value.participant__email)
                    }
                }
            })
        })

        let submittedErrorObject = {
            status: arrayEmailsSubmitted.length !== 0 ? true : false,
            stringArr: arrayEmailsSubmitted
        }


        let expiryValue = ''

        if (this.state.checkBoxData.length === 1) {
            expiryValue = this.state.checkBoxData[0].expiry_date
        } else {
            expiryValue = ''
        }


        this.setState({
            submittedAssessment: { ...submittedErrorObject },
            setExpiryDateModal: data,
            expiryValue
        }, () => {

        })
    }

    setReportThemeToggle(data) {
        this.setState({
            setReportThemeModal: data
        })
    }



    removeFromBatch(data) {
        const { dispatch } = this.props
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push(val.id)
            })
            dispatch(manageBatchActions.removeFromBatchAction({
                sellerId: this.props.getOrgSellerId.sellerId,
                orgId: this.props.getOrgSellerId.orgId,
                batchId: this.state.batchIdState,
                data: {
                    user_assessment_id: dataEmail
                }
            }))
        }

    }

    setExpiryDate(data) {
        const { dispatch } = this.props
        var date = data.expiry_list;
        var newdate = date.split("/").reverse().join("-");
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push(val.id)
            })
            dispatch(manageBatchActions.setExpiryDateAction({
                orgId: this.props.getOrgSellerId.orgId,
                batchId: this.state.batchIdState,
                data: {
                    users_assessment_id: dataEmail,
                    expiry_date: newdate
                }
            }))
        }
    }

    handleExpiryPlaceholder = (data) => {
        if (data == '') {
            return ''
        }
        else {
            if (data.length > 1) {
                return moment()
            }
            else {
                const endDate = moment(data[0].expiry_date, 'YYYY-MM-DD').format('DD-MM-YYYY')
                let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
                let dateArr = endDate.split('-')
                let dicreement = dateArr[1] - 1
                let changedDate = months[dicreement]
                dateArr[1] = changedDate
                let properDate = dateArr.join('-')
                return properDate;
            }
        }
    }

    enableReport(data) {
        const { dispatch } = this.props
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push(val.id)
            })
            dispatch(manageBatchActions.enableReportsAction({
                orgId: this.props.getOrgSellerId.orgId,
                batchId: this.state.batchIdState,
                data: {
                    users_assessment_id: dataEmail
                }
            }))
        }
    }

    disableReport(data) {
        const { dispatch } = this.props
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push(val.id)
            })
            dispatch(manageBatchActions.disableReportsAction({
                orgId: this.props.getOrgSellerId.orgId,
                batchId: this.state.batchIdState,
                data: {
                    users_assessment_id: dataEmail
                }
            }))
        }
    }

    deleteReport(data) {
        const { dispatch } = this.props
        if (this.state.checkBoxData.length !== 0) {
            let checkboxIdArr = []
            this.state.checkBoxData.map(val => {
                checkboxIdArr.push(val.id)
            })
            dispatch(manageBatchActions.deleteReportsAction({
                orgId: this.props.getOrgSellerId.orgId,
                batchId: this.state.batchIdState,
                data: {
                    users_assessment_id: checkboxIdArr
                }
            }))
            this.setState({
                deleteReportText: ''
            })
        }

    }

    unsubmitAssessment(data) {
        const { dispatch } = this.props
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push(val.id)
            })
            dispatch(manageBatchActions.unsubmittedAssessmentAction({
                orgId: this.props.getOrgSellerId.orgId,
                batchId: this.state.batchIdState,
                data: {
                    users_assessment_id: dataEmail
                }
            }))
        }
    }

    resetAssessmentAction() {
        const { dispatch } = this.props;
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push({
                    assessment_id: val.id,
                    organisation_id: this.state.orgId,
                    batch_id: this.state.batchIdState
                })
            });

            // Counter to track completed requests
            let completedRequests = 0;
            let successCount = 0;
            let errorMessages = [];

            dataEmail.forEach(data => {
                dispatch(manageBatchActions.resetAssessmentAction(data))
                    .then(result => {
                        completedRequests++;
                        if (result.success) {
                            successCount++;
                        } else {
                            errorMessages.push(result.message);
                        }

                        // When all requests are complete
                        if (completedRequests === dataEmail.length) {
                            // Close the modal first
                            this.setState({ resetAssessmentModal: false }, () => {
                                // Then show the appropriate message
                                if (successCount === dataEmail.length) {
                                    // All successful
                                    swal({
                                        title: "Success",
                                        text: result.message,
                                        icon: "success"
                                    });
                                } else if (successCount === 0) {
                                    // All failed
                                    swal({
                                        title: "Error",
                                        text: errorMessages.join('\n'),
                                        icon: "error"
                                    });
                                } else {
                                    // Mixed results
                                    swal({
                                        title: "Partial Success",
                                        text: `Successfully reset ${successCount} out of ${dataEmail.length} assessments.`,
                                        icon: "warning"
                                    });
                                }
                            });
                        }
                    });
            });
        }
    }






    setReportTheme(data) {
        const { dispatch } = this.props
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push(val.id)
            })
            dispatch(manageBatchActions.setReportThemeAction({
                orgId: this.props.getOrgSellerId.orgId,
                batchId: this.state.batchIdState,
                data: {
                    participants: dataEmail,
                    theme_id: data.theme_list
                }
            }))
        }
    }


    getSellerOrgId() {
        const { dispatch } = this.props;
        const { locationId } = this.state;
        const { orgList } = this.props;


        let organisationId = parseInt(locationId, 10)

        orgList !== '' &&
            this.mapOrgList({
                orgList,
                locationId: organisationId,
                dispatch
            })

    }

    mapOrgList(objectData) {
        const { orgList, locationId, dispatch } = objectData

        let hasId = false;

        orgList.map(val => {
            if (locationId == val.id) {
                hasId = true;
                return this.setStateForIds({
                    val,
                    dispatch,
                    locationId
                })
            }
        })

        this.setState({
            hasProperOrgId: hasId,
            idLoader: false
        })

    }


    setStateForIds(objectData) {
        const { locationId, val, dispatch } = objectData;

        return this.setState({
            orgId: locationId,
            sellerId: val.seller__id,
            getImpId: true,
        }, () => {
            const { orgId, sellerId, batchIdState } = this.state;


            dispatch(manageBatchActions.detailedBatchAction(orgId, batchIdState))


            dispatch(manageBatchActions.getAllotedUnallotedListAction({
                data: {
                    batch_id: batchIdState,
                    organisation_id: orgId
                }
            }))
            dispatch(organisationAction.setIds({
                orgId,
                sellerId
            }))

            dispatch(manageBatchActions.addOrgMandate({
                sellerId,
                orgId
            }))
        })
    }


    setDevelopmentPlanAction(data) {


        const { dispatch } = this.props;
        let checkBoxId = [];
        this.state.checkBoxData.map(val => {
            checkBoxId.push(val.id)
        })

        dispatch(manageBatchActions.setDevelopmentAction({
            data: {
                user_assessment_id: checkBoxId,
                dev_plan: data.dev_plan === '1' ? true : false
            },
            getAllot: {
                data: {
                    batch_id: this.state.batchIdState,
                    organisation_id: this.state.orgId
                }
            }
        }))
    }

    modalOpener(data) {

        let stringAttach = '';
        let stringUnattach = '';
        let stringRemaining = [];
        let remaining = [...this.props.getCustomData.results]
        if (data !== false) {
            data.report_list.map(val => {
                if (stringAttach === '') {
                    stringAttach = stringAttach + val.relation_group_name
                } else if (stringAttach !== '') {
                    stringAttach = stringAttach + ', ' + val.relation_group_name
                }
                stringRemaining.push(val)
                remaining.map((value, key) => {
                    if (val.relation_group_id === value.id) {
                        remaining.splice(key, 1)
                    }
                })
            })

            remaining.map(val => {
                if (stringUnattach === '') {
                    stringUnattach = stringUnattach + val.relation_group_name
                } else if (stringUnattach !== '') {
                    stringUnattach = stringUnattach + ', ' + val.relation_group_name
                }
            })


        }



        this.setState({
            tableModal: data,
            topTextModal: stringAttach,
            bottomTextModal: stringUnattach
        })

    }

    setCustomReportAction(data) {
        const { dispatch } = this.props;

        let dataName = []
        data.map(val => {
            dataName.push({
                id: val.id,
                relation_group_name: val.name
            })
        })
        let selectedUserId = [];
        this.state.checkBoxData.map(value => {
            selectedUserId.push(value.id)

        })

        let postData = {
            get: {
                data: {
                    batch_id: this.state.batchIdState,
                    organisation_id: this.state.orgId
                }
            },
            data: {
                users_assessment_id: selectedUserId,
                custom_access: 0,
                assessment_report_list: dataName
            }
        }

        dispatch(manageBatchActions.setReportCustom(postData))
    }

    showTableModalToggle(data) {
        this.setState({
            tableModal: data
        })
    }

    sortBy(columnKey, type, tableName) {

        if (tableName === 'organisationallotTable') {
            this.setState({ sortTypeallot: type })
            const arrayCopy = this.state.organisationallotTable === '' ? this.props.allotedUnallotedList : this.state.organisationallotTable;
            arrayCopy.sort(compareBy(columnKey, this.state.sortTypeallot));
            this.setState({ organisationallotTable: arrayCopy })
        }

    }

    toggleReport(data) {
        const { dispatch } = this.props;
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = this.state.checkBoxData.map(val => val.id);

            // Count enabled and disabled reports
            const enabledCount = this.state.checkBoxData.filter(item => item.enable_report).length;
            const disabledCount = this.state.checkBoxData.length - enabledCount;

            // Determine action based on majority state
            const action = enabledCount >= disabledCount ?
                manageBatchActions.disableReportsAction :
                manageBatchActions.enableReportsAction;

            dispatch(action({
                orgId: this.props.getOrgSellerId.orgId,
                batchId: this.state.batchIdState,
                data: {
                    users_assessment_id: dataEmail
                }
            }));
        }
    }




    toggleMandateGroup(data) {


        let batchDetails = [...this.props.batchDetails]
        let add_org_mandate = [...this.props.add_org_mandate]

        let counter = false
        batchDetails.map(val => {
            add_org_mandate.map(value => {
                if (value.assessor_group__assessor_name === val.organisation_mandate_group__assessor_group__assessor_name) {
                    updateMandateGroup["0"].value = value.id
                    updateMandateGroup["0"].valid = true
                    counter = true
                }
            })
        })
        if (!counter) {
            updateMandateGroup["0"].value = 'Choose an Option...'
            updateMandateGroup["0"].valid = false
        }


        this.setState({
            changeMandateGroup: !this.state.changeMandateGroup
        })
    }


    updateMandateAction(data) {

        const { dispatch } = this.props;



        dispatch(manageBatchActions.updateMandateGroupAction({
            batchId: this.state.batchIdState,
            orgId: this.state.orgId,
            data: {
                mandate_group_id: parseInt(data.assessor_group__assessor_name, 10)
            }
        }))
    }

    expiryCallback(data) {
        this.setState({ expiryPlaceholderValidator: data })
    }

    renderManageOrganization() {


        const { batch_details_loading, batch_details_error, getThemeRep, allotedUnallotedList, alloted_unalloted_list_loading, alloted_unalloted_list_error, developmentPlanLoading, developmentPlanResponse } = this.props;



        reportThemeData.map((element) => {

            if (element.key === 'theme_list') {
                element.elementConfig.options = getThemeRep;
            }
        });

        allotedUnallotedList !== '' &&
            allotedUnallotedList.map(val => {
                if (val.dev_plan === 0) {
                    val.dev_plan = 'Integrated'
                } else if (val.dev_plan === 1) {
                    val.dev_plan = 'Stand-alone'
                }
                val["idString"] = `${val.id}`
            })

        tables.UnallotedAssesments.map(val => {
            val['modalOpener'] = (data) => this.modalOpener(data)
        })











        return (
            <div className="container custom-container my-5" >
                <div style={{ marginBottom: 30 }}>
                    <CommonBreadCrumb
                        data={this.state.breadCrumbData}
                    />
                    <div className="bg-green rounded-top">
                        {
                            (!batch_details_loading && !batch_details_error) ?
                                <p className="text-center text-uppercase py-2 text-white mb-0"> BATCH DETAILS </p>
                                :
                                <div className="text-right d-flex" style={{ justifyContent: 'space-between' }}>
                                    <p></p>
                                    <p className="text-center text-uppercase py-2 text-white mb-0"> BATCH DETAILS </p>
                                    <LoaderComp color={'white'} />
                                </div>


                        }
                    </div>
                    {
                        (!batch_details_loading && !batch_details_error) &&
                        <div className="animation-fade-in">
                            <SettingsHead
                                buttonData={
                                    [
                                        {
                                            id: 1,
                                            heading: "Update Minimum Respondents",
                                            state: this.state.addBatchDetailModal,
                                            toggler: this.toggleBatchDetail.bind(this),
                                        },
                                        {
                                            id: 2,
                                            heading: "Update Mandate Group",
                                            state: this.state.changeMandateGroup,
                                            toggler: this.toggleMandateGroup.bind(this),
                                        }
                                    ]
                                }
                                secondColumn={false}
                                modal={this.toggleModal.bind(this)}
                                deleteAction={''}
                                widthClass="col-md-12"
                            />
                        </div>
                    }
                    <TableNew
                        data={this.props.batchDetails}
                        columns={tables.BatchDetails}
                        showSlNo="false"
                    />
                </div>

                <div style={{ marginBottom: 30 }}>
                    <div className="bg-green rounded-top">
                        {
                            (!alloted_unalloted_list_loading && !alloted_unalloted_list_error) ?
                                <p className="text-center text-uppercase py-2 text-white mb-0"> ACTIVE ASSESSMENTS </p>
                                :
                                <div className="text-right d-flex" style={{ justifyContent: 'space-between' }}>
                                    <p></p>
                                    <p className="text-center text-uppercase py-2 text-white mb-0"> ACTIVE ASSESSMENTS </p>
                                    <LoaderComp color={'white'} />
                                </div>
                        }
                    </div>
                    {
                        (!alloted_unalloted_list_loading && !alloted_unalloted_list_error) &&
                        <div className="animation-fade-in">
                            <SettingsHead
                                buttonData={
                                    this.state.buttonBatchDetailsData
                                }
                                secondColumn={false}
                                modal={this.toggleModal.bind(this)}
                                deleteAction={''}
                                widthClass="col-md-12"
                            />
                        </div>
                    }

                    <CustomTableNew
                        data={this.props.allotedUnallotedList}
                        columns={localStorage.getItem('usertype').split(',').includes('seller_admin') ? tables.UnallotedAssesments_seller_admin : localStorage.getItem('usertype').split(',').includes('organisation_admin') ? tables.UnallotedAssesments_org_admin : tables.UnallotedAssesments}
                        checkboxData={this.state.checkBoxData}
                        showSlNo="false"
                        checkbox="true"
                        selectCheckBox={this.selectAllBatchDetailsBox.bind(this)}
                        getData={this.getSelectedData.bind(this)}
                        format={[{
                            format: 'icon',
                            key: 'is_submited'
                        }]}
                        CheckKey={'idString'}
                        modalOpener={this.modalOpener.bind(this)}
                        sortBy={(key) => this.sortBy(key, !this.state.sortTypeallot, 'organisationallotTable')}
                        sortType={this.state.sortTypeallot}
                        handleExpiryCallBack={this.expiryCallback.bind(this)}
                    />

                    {
                        this.state.addBatchDetailModal &&
                        <ModalNew2
                            heading="Update Minimum Respondents"
                            showModal={this.state.addBatchDetailModal}
                            formData={BatchDetail}
                            selects={['']}
                            action={this.onUpdateMinRes.bind(this)}
                            toggleModal={this.toggleBatchDetail.bind(this)}
                            viewMessage={[{ text: '' }]}
                            triggerType={"Add"}
                        />
                    }
                    {
                        this.state.changeMandateGroup &&
                        <ModalNew2
                            heading="Update Mandate Group"
                            showModal={this.state.changeMandateGroup}
                            formData={updateMandateGroup}
                            selects={['']}
                            action={this.updateMandateAction.bind(this)}
                            toggleModal={this.toggleMandateGroup.bind(this)}
                            viewMessage={[{ text: '' }]}
                            triggerType={"Update"}
                        />
                    }
                    {
                        this.state.removeFromBatchModal &&
                        <ModalNew2
                            heading="REMOVE ASSESSMENT FROM BATCH"
                            showModal={this.state.removeFromBatchModal}
                            formData={[]}
                            selects={['']}
                            action={this.removeFromBatch.bind(this)}
                            toggleModal={this.removeFromBatchToggle.bind(this)}
                            viewMessage={[{ text: `Are you sure you want to remove these assessments from this batch?` }]}
                            triggerType={"YES"}

                            disabledButton={true}
                        />
                    }
                    {
                        this.state.unsubmitAssessmentModal &&
                        <ModalNew2
                            heading="UNSUBMIT ASSESSMENT"
                            showModal={this.state.unsubmitAssessmentModal}
                            formData={[]}
                            selects={['']}
                            action={this.unsubmitAssessment.bind(this)}
                            toggleModal={this.unsubmitAssessmentToggle.bind(this)}
                            viewMessage={[{ text: `Are you sure you want to unsubmit these assessments?` }]}
                            triggerType={"YES"}

                        />
                    }

                    {
                        this.state.toggleReportModal &&
                        <ModalNew2
                            heading={`${this.state.reportAction.toUpperCase()} REPORT`}
                            showModal={this.state.toggleReportModal}
                            formData={[]}
                            selects={['']}
                            action={this.toggleReport.bind(this)}
                            toggleModal={this.toggleReportToggle.bind(this)}
                            viewMessage={[{
                                text: `Are you sure you want to ${this.state.reportAction} these reports? 
                   This will ${this.state.reportAction} ${this.state.affectedReportCount} out of ${this.state.checkBoxData.length} selected report(s).`
                            }]}
                            triggerType={"YES"}
                        />
                    }




                    {
                        this.state.deleteReportModal &&
                        <ModalNew2
                            heading="DELETE ASSESSMENT"
                            showModal={this.state.deleteReportModal}
                            formData={[]}
                            selects={['']}
                            action={this.deleteReport.bind(this)}
                            toggleModal={this.deleteReportToggle.bind(this)}
                            viewMessage={[{ text: this.state.deleteReportText }]}
                            triggerType={"DELETE"}

                        />
                    }
                    {
                        this.state.setReportThemeModal &&
                        <ModalNew2
                            heading="SET REPORT THEME"
                            showModal={this.state.setReportThemeModal}
                            formData={reportThemeData}
                            selects={['report_theme_name']}
                            action={this.setReportTheme.bind(this)}
                            toggleModal={this.setReportThemeToggle.bind(this)}
                            viewMessage={[{ text: `You have selected ${this.state.checkBoxData.length} assessment.` }]}
                            triggerType={"SUBMIT"}
                            noReset={'noReset'}
                            selectKey={['id']}
                        />
                    }
                    {
                        this.state.setExpiryDateModal &&
                        <ModalNew2
                            heading="CHANGE EXPIRY DATE"
                            showModal={this.state.setExpiryDateModal}
                            formData={[
                                {
                                    key: 'expiry_list',
                                    type: 'date',
                                    value: this.state.expiryValue,
                                    valid: false,
                                    elementConfig: {
                                        name: 'expiry',
                                        label: 'SET EXPIRY DATE',
                                        placeholder: this.handleExpiryPlaceholder(this.state.expiryPlaceholderValidator),
                                        options: []
                                    },
                                    validation: {
                                        required: true,
                                        message: "is required"
                                    }
                                }
                            ]}
                            selects={['']}
                            action={this.setExpiryDate.bind(this)}
                            toggleModal={this.setExpiryDateToggle.bind(this)}
                            viewMessage={[{ text: `You have selected ${this.state.checkBoxData.length} assessment.` }]}
                            triggerType={"SUBMIT"}

                        />
                    }



                    {
                        this.state.setDevelopmentPlanModal &&

                        <ModalNew2
                            heading="SET DEVELOPMENT PLAN"
                            showModal={this.state.setDevelopmentPlanModal}
                            formData={setDevPlan}
                            selects={['dev_plan']}
                            hardCodeSelects={[
                                {
                                    id: 0,
                                    value: 'Integrated'
                                },
                                {
                                    id: 1,
                                    value: 'Stand-Alone'
                                }
                            ]}
                            action={this.setDevelopmentPlanAction.bind(this)}
                            toggleModal={this.setDevelopmentPlanToggle.bind(this)}
                            viewMessage={[{ text: `You have selected ${this.state.checkBoxData.length} assessment.` }]}
                            triggerType={"SUBMIT"}
                            noReset={'noReset'}
                            selectKey={['id']}
                            disableButton={this.state.vviSelected ? true : false}
                            vviSelected={this.state.vviSelected}
                        />
                    }

                    {
                        this.state.setCustomReportAccess &&
                        <ModalNew2
                            heading="SET CUSTOM REPORT ACCESS"
                            showModal={this.state.setCustomReportAccess}
                            formData={this.props.getCustomData}
                            selects={['']}
                            checkboxKey={'results'}
                            action={this.setCustomReportAction.bind(this)}
                            toggleModal={this.setCustomReportToggle.bind(this)}
                            viewMessage={[{ text: `You have selected ${this.state.checkBoxData.length} assessment.` }]}
                            triggerType={"SUBMIT"}
                            selectKey={['']}
                            disableButton={this.state.vviSelected ? true : false}
                            checkboxModal={{
                                heading: 'Relation Groups',
                                labelKey: 'relation_group_name',
                                selectAll: true,
                                deselectAll: true,
                                data: this.state.setCustomReportData,
                                vviSelected: this.state.vviSelected
                            }}
                            vviSelected={this.state.vviSelected}
                        />
                    }

                    {
                        this.state.removeCustomReportAccess &&
                        <ModalNew2
                            heading="REMOVE CUSTOM REPORT ACCESS"
                            showModal={this.state.removeCustomReportAccess}
                            formData={[]}
                            selects={['']}
                            action={this.removeCustomReportAction.bind(this)}
                            toggleModal={this.removeCustomReportToggle.bind(this)}
                            viewMessage={[{ text: 'Are you sure you want to remove custom report access to these assessments?' }]}
                            triggerType={"REMOVE"}
                            selectKey={['']}
                            checkboxModal={{
                                heading: `You have selected ${this.state.checkBoxData.length} assessment.`,
                                selectAll: false,
                                deselectAll: false,
                            }}
                            disableButton={this.state.vviSelected ? true : false}
                            vviSelected={this.state.vviSelected}
                        />
                    }

                    {
                        this.state.tableModal &&
                        <ModalNew2
                            heading="User Report Access"
                            showModal={this.state.tableModal}
                            formData={[]}
                            selects={['']}
                            onlyBackButton={true}
                            action={() => { this.modalOpener(false) }}
                            toggleModal={this.modalOpener.bind(this)}
                            viewMessage={[]}
                            triggerType={"OK"}
                            selectKey={['']}
                            checkboxModal={'a'}
                            tableModalText={{
                                topHeading: 'The following reports are accessible to the user(s):',
                                topText: this.state.topTextModal,
                                bottomHeading: 'The following reports are not accessible to the user(s):',
                                bottomText: this.state.bottomTextModal
                            }}
                        />
                    }

                    {
                        this.state.addIndividualAnalytics &&
                        <ModalNew2
                            heading="Add Individual Analytics"
                            showModal={this.state.addIndividualAnalytics}
                            formData={[]}
                            action={(data) => this.addIndividualAnalyticsAction(data)}
                            toggleModal={this.addIndividualAnalyticsToggle.bind(this)}
                            viewMessage={[{ text: 'Add Individual Analytics?' }]}
                            triggerType={"OK"}
                        />
                    }
                    {
                        this.state.removeIndividualAnalytics &&
                        <ModalNew2
                            heading="Remove Individual Analytics"
                            showModal={this.state.removeIndividualAnalytics}
                            formData={[]}
                            action={(data) => this.removeIndividualAnalyticsAction(data)}
                            toggleModal={this.removeIndividualAnalyticsToggle.bind(this)}
                            viewMessage={[{ text: 'Remove Individual Analytics?' }]}
                            triggerType={"OK"}
                        />
                    }

                    {
                        this.state.resetAssessmentModal &&
                        <ModalNew2
                            heading="RESET ASSESSMENT"
                            showModal={this.state.resetAssessmentModal}
                            formData={[]}
                            selects={['']}
                            action={this.resetAssessmentAction.bind(this)}
                            toggleModal={this.resetAssessmentToggle.bind(this)}
                            viewMessage={[{
                                text: `
                <div class="reset-warning text-center">
                    <div class="warning-icon mb-3">
                        <i class="fas fa-exclamation-triangle fa-2x text-warning"></i>
                    </div>
                    <div class="warning-heading mb-2">
                        <strong>Warning: This action cannot be undone!</strong>
                    </div>
                    <div class="warning-text mb-3">
                        Resetting these assessments will:
                        <ul class="text-left mt-2 mb-3">
                            <li>Clear all participant responses</li>
                            <li>Remove all submitted data and results</li>
                            <li>Reset the assessment to its original state</li>
                        </ul>
                        Assessment settings and configurations will be retained.
                    </div>
                    <div class="confirmation-text">
                        Are you sure you want to reset these ${this.state.checkBoxData.length} assessment(s)?
                    </div>
                </div>
            `
                            }]}
                            triggerType={"YES"}
                        />
                    }


                </div>
            </div>
        )
    }

    render() {

        const toggleReportButton = this.state.buttonBatchDetailsData.find(btn => btn.id === 4);
        if (toggleReportButton) {
            const allEnabled = this.state.checkBoxData.every(item => item.enable_report);
            const allDisabled = this.state.checkBoxData.every(item => !item.enable_report);
            toggleReportButton.heading = allEnabled ? "DISABLE REPORT" : allDisabled ? "ENABLE REPORT" : "TOGGLE REPORT";
        }





        if (!this.props.error) {
            return (
                <div>
                    <NavBar />
                    {
                        this.state.idLoader ?
                            <div style={{ height: 'calc(100vh - 150px)' }} className="container d-flex justify-content-center">
                                <LoaderComp color={'black'} />
                            </div>
                            :
                            this.state.hasProperOrgId ?
                                this.renderManageOrganization()
                                :
                                <Page404 />

                    }
                    <Footer />
                </div>
            );
        } else {
            return (

                <h1>Something went wrong</h1>
            );
        }

    }

}

function mapStateToProps(state) {


    const orgError = state.organisation.error;
    const orgLoading = state.organisation.loading;
    const orgList = (!orgError && !orgLoading) ? state.organisation.organisation.data.organisation_list : '';


    const { alloted_unalloted_list_loading, alloted_unalloted_list_error } = state.allotUnallotBatch;
    const allotedUnallotedList = (!alloted_unalloted_list_loading && !alloted_unalloted_list_error) ? state.allotUnallotBatch.alloted_unalloted_list.data.organisation_batch_assessment : ''



    const { batch_details_loading, batch_details_error } = state.batchDetail;
    const batchDetails = (!batch_details_loading && !batch_details_error) ? state.batchDetail.batch_details.data.organisation_batch_details : ''

    const getOrgSellerId = state.setSellerAndOrgId


    const { get_theme_report_loading, get_theme_report_error } = state.getReportTheme;
    const getThemeRep = (!get_theme_report_loading && !get_theme_report_error) ? state.getReportTheme.get_theme_report.data.theme_list : ''


    const { getCustomError, getCustomLoading, getCustomData } = state.getCustomReportState;


    const { developmentPlanLoading } = state.developmentPlan;
    const developmentPlanError = state.developmentPlan.error;
    const developmentPlanResponse = (!developmentPlanLoading && !developmentPlanError) ? state.developmentPlan.data.data.results : [];
    const developmentPlanResponseCode = (!developmentPlanLoading) ? state.developmentPlan.data.status : '';


    const { add_org_mandate_loading, add_org_mandate_error } = state.addOrgMandate;
    const add_org_mandate = (!add_org_mandate_loading && !add_org_mandate_error) ? state.addOrgMandate.add_org_mandate.data.organisation_assessor_group_list : []

    return {
        allotedUnallotedList,
        alloted_unalloted_list_loading,
        alloted_unalloted_list_error,
        batch_details_loading,
        batch_details_error,
        batchDetails,
        getOrgSellerId,
        orgError,
        orgLoading,
        orgList,
        get_theme_report_loading,
        get_theme_report_error,
        getThemeRep,
        getCustomError,
        getCustomLoading,
        getCustomData,

        developmentPlanLoading,
        developmentPlanResponse,
        developmentPlanResponseCode,

        add_org_mandate,
    };
}

export default withRouter(connect(mapStateToProps)(BatchDetails));


// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/DetailLinks/BatchDetails.js